import * as React from 'react';
var AccordionContext = /*#__PURE__*/React.createContext({});
AccordionContext.displayName = 'AccordionContext';
export default AccordionContext;